import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="company_news" pageTitle="Noticias de la empresa" pageDescription="Los últimos anuncios, alianzas e hitos de QbD Group — mantente informado sobre nuestro crecimiento e impacto." />;

export const Route = createFileRoute("/es/noticias/")({
  head: () => buildRouteHead("/es/noticias"),
  component: ContentListingRoute,
});

